import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { Card, InputNumber, Button, Row, Col, Typography, message } from "antd";
import styled from "styled-components";
//import icons
import LogoIcon from "../assets/icons/LogoIcon";

import { verifyAuthenticationOtp,resendOtpCode} from "../api/UserTypeAPI";
import { useAuthenticatedSession, useAuthentication } from "../context/AuthProvider";

const { Text } = Typography;
const StyledDivWrapper = styled.div`
  display: flex;
  margin: auto;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  text-align: center;
`;

const StyledDivImageWrapper=styled.div`
display: flex;
justify-content: center;
align-items: center;
margin: auto;
`;


const StyledRow=styled(Row)`
.ant-col {
    margin: 10px 0px;
  }
`;

const VerificationOTP = (props) => {
  const [otpValue, setOtpValue] = useState();
  const [loading, setLoading] = useState(false);
  const params = useParams();
  const { verifyOTP, resendOTP, subscribeOTP } = useAuthentication();

  function resendOtpVerification() {
    resendOTP({ userId: params.userId })
  }

  function onChange(value) {
    setOtpValue(value);
  }

  function onVerifyOtp() {
    setLoading(true);

    verifyOTP({
      otp: otpValue,
      userId: params.userId,
    })
    .catch(() => setLoading(false));
  };

  return (
    <StyledDivWrapper>
      <Card style={{ width: 320 ,background:"white"}}>
          <StyledDivImageWrapper>
        <LogoIcon
          width={"50%"}     
        />
        </StyledDivImageWrapper>

        <StyledRow gutter={24} >
          <Col span={24}>
            <Text>
              <b>Enter the One Time Password (OTP) sent to your E-mail or Phone.</b>
            </Text>
          </Col>

          <Col span={24}>
            <InputNumber
              onChange={onChange}
              onPressEnter={ () => onVerifyOtp()}
              placeholder="Enter One Time Password"
              style={{ width: "100%" }}
            />
          </Col>
          <Col span={24}>
            <Button
              type="primary"
              style={{ width: "100%" }}
              loading={loading}
              onClick={() => onVerifyOtp()}
            >
              Verify OTP
            </Button>
          </Col>
          <Col span={24}>
            <Text>
              <b>OTP is valid for 10 minutes</b>
            </Text>
          </Col>
          <Col span={24}>
            <Text
                onClick={() => resendOtpVerification()}
              style={{ cursor: "pointer", color: "#7bad7e" }}
            >
              <b>Resend OTP</b>
            </Text>
            <br />
            <span style={{ fontSize: "12px", display: "inline-block", marginTop: "20px" }}>
              Still not receiving the OTP?
              <br />
              <Text
                style={{
                  cursor: "pointer",
                  color: "#7bad7e",
                  fontWeight: "bold",
                  fontSize: "13px",
                }}
                onClick={() => subscribeOTP({ userId: params.userId })}
              >
                Resend 2FA Subscription Email
              </Text>
            </span>
          </Col>
        </StyledRow>
      </Card>
    </StyledDivWrapper>
  );
};

export default VerificationOTP;
